/**
 * Card ID utilities.
 *
 * Card IDs in this codebase follow the pattern:
 *   <SETCODE>-<NUMBER>[_<suffix>]
 *
 * SETCODE and NUMBER never contain underscores.
 * Everything from the first underscore onwards is the variant suffix
 * (e.g. `_p1`, `_pcc_bcgf23-24`, `_1st-anni-set`, `_winpack-v7`).
 *
 * Japanese-locale variants use a HYPHEN, not an underscore:
 *   OP01-001-JP          → base is OP01-001-JP  (no strip)
 *   OP01-001-JP_p1       → base is OP01-001-JP  (strip after first underscore)
 */

/**
 * Return the base card ID by stripping everything from the first underscore
 * to the end of the string.
 *
 * Returns an empty string for falsy input (e.g. while the modal card prop is
 * still undefined on first render).
 */
export function baseCardId(id: string | undefined | null): string {
  if (!id) return ''
  return id.replace(/_.*$/, '')
}
